import { createContext, useContext } from "react";
import type { ReactNode } from "react";

export type ErrorFeedback = (content: ReactNode, duration?: number) => boolean;
export const PersistentErrorFeedbackContext = createContext<ErrorFeedback | null>(null);
export const usePersistentErrorFeedback = () => useContext(PersistentErrorFeedbackContext);
